// 数字限定
import toChinese from "@/utils/chinese_number";

export function toFixed(value: number | null, digit: number = 2): number {
    if (value == null) {
        return 0
    }
    return parseFloat(value.toFixed(digit))
}

// 时间转换
export function formatTime(date: Date | number | null, fmt: string = 'YYYY.mm.dd HH:MM:SS') {
    if (!date) {
        return undefined
    }
    if (typeof date === 'number') {
        date = new Date(date)
    }
    let ret
    const opt: any = {
        'Y+': date.getFullYear().toString(), // 年
        'm+': (date.getMonth() + 1).toString(), // 月
        'd+': date.getDate().toString(), // 日
        'H+': date.getHours().toString(), // 时
        'M+': date.getMinutes().toString(), // 分
        'S+': date.getSeconds().toString() // 秒
    }
    for (const k in opt) {
        ret = new RegExp(`(${k})`).exec(fmt)
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
        }
    }
    return fmt
}

// 中国数字
export const chineseNumber = toChinese;

// 英文数字
const _englishSeqNumber = ['A', 'B', 'C', 'D', 'E', 'F', "G", 'H', 'I', 'J', 'K', "L", 'M', "N", 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

// 数字转英文序号
export function englishSeqNumber(value: number | string): string {

    if (typeof value == "string") {
        value = parseInt(value)
    }

    if (value != null && value < _englishSeqNumber.length) {
        return _englishSeqNumber[value]
    }

    return ""
}